import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ImageService } from '../../../services/image.service';

@Component({
  selector: 'pop-inform',
  standalone: true,
  imports: [CommonModule, NzIconModule],
  templateUrl: './pop-inform.component.html',
  styleUrl: './pop-inform.component.scss'
})
export class PopInformComponent implements AfterViewInit {

  @ViewChild('popInform') popInform!: ElementRef<HTMLDivElement>

  @Input() type: 'success' | 'warning' | 'loading' = 'success'
  @Input() pos: number = 0
  @Input() direction: 'top' | 'bottom' = 'top'

  public imageServe = inject(ImageService)

  ngAfterViewInit() {
    let position = (this.pos > 0 ? this.pos : 11.5625)
    this.popInform.nativeElement.style[this.direction] = position + 'rem'
  }

}
